import React, { Fragment } from "react";
import { Form } from "react-bootstrap";
import $ from "jquery";
import DescPopover from "../../popovers/DescPopover";

const TextForm = (props) => {
    const { value, onChangeValue, req, labelTxt, placeholderTxt, name, helper, id, readOnly } = props;
    return (
        <Fragment>
            <Form.Group>
                {labelTxt && (
                    <Form.Label>
                        {labelTxt} {req && <span className="required">*</span>}
                        {helper && <DescPopover popoverTxt={<p>{helper}</p>} />}
                    </Form.Label>
                )}
                <Form.Control
                    type="text"
                    placeholder={placeholderTxt}
                    name={name}
                    id={id}
                    value={value}
                    onChange={(e) => {
                        $(`#${id}`).removeClass("is-invalid");
                        onChangeValue(e);
                    }}
                    className={req ? "req" : ""}
                    readOnly={readOnly ? true : false}
                />
            </Form.Group>
        </Fragment>
    );
};

export default TextForm;
